<div class="py-2">
    <div class="container">
      <div class="row">
        <div class="col-md-12 py-1">
		<p><button type="button" class="btn-primary pull-right" (click)="updateRole('')">Create New</button></p>
		</div>
		<div class="col-md-12 py-1">
			<div class="form-group"> <label for="accountDomain">Role</label>
              <select class='form-control' [(ngModel)]='selectedRole' (ngModelChange)='onChange($event)'>
				<option *ngFor='let role of roles' [ngValue]="role">{{role.role}}</option>
			  </select><br />
			  <span *ngIf="selectedRole">{{selectedRole.name}}<button type="button" (click)="updateRole(selectedRole)" class="btn-primary">Edit</button></span>
		    </div>
        </div>
      </div>
	  <div class="col-md-12 py-1">
<div class="alert alert-success" *ngIf="Response!=''">
	<strong>Success!</strong> {{Response}} .
</div>
<!-- <form (ngSubmit)="onSubmit(aclForm, model.id)" #aclForm="ngForm"> --><!-- model.permissionSet[method.name] -->
<form (ngSubmit)="onSubmit(aclForm)" #aclForm="ngForm">
       <div class="row col-md-4" *ngFor="let acl of ACLControls; let i = index">
	     <label for="{{acl.Module}}">{{acl.Module}}</label>
		 <div class="col-md-12 py-1" *ngFor="let Functioncall of acl.Functioncalls; let j = index">
		   <span class="col-md-12" *ngFor="let method of Functioncall.methods; let k = index">
		     <input name="{{method.name}}" [(ngModel)]="method.value" type="checkbox" (change)="updateSet(i,j,k,method.value)" ng-true-value="'true'" ng-false-value="'false'" /><label for="{{method.label}}">{{method.label}}</label>
		   </span>
		 </div>
	   </div>
	   <button type="submit" *ngIf="ACLControls!=''" class="btn btn-primary" >Update</button>
</form>
</div>
  </div> 
</div>